import React from "react";
import { Box, Stack } from "@mui/material";
import Heading6 from "../typography/heading-06";
import Body3 from "../typography/body-03";
import { VERBIAGE_CONSTANTS } from "../../utils/verbiage.constants";
import styles from "./index.module.scss";

const MessageSection = ({ title, items, testId }) => (
	<Box className={styles.section} data-testid={testId}>
		<Heading6 text={title} fontType="semibold" extraClass={styles.title} />
		{items.length === 0 ? (
			<Body3 text={VERBIAGE_CONSTANTS.AURA_MESSAGES_NONE} extraClass={styles.none} />
		) : (
			<Stack component="ul" direction="column" gap={0.5} className={styles.list}>
				{items.map((message, i) => (
					<li key={message.id || i}>
						<Body3 text={message.text} />
					</li>
				))}
			</Stack>
		)}
	</Box>
);

// LC-696 / PathA-5.11–5.14: AURA's own messages, exactly as written and in the order
// AURA returned them. Both sections always show; each reads "None" when empty.
const AuraEligibilityMessages = ({ messages }) => (
	<Stack direction="column" gap={2} className={styles.root}>
		<MessageSection
			title={VERBIAGE_CONSTANTS.AURA_FAILS_TITLE}
			items={messages?.failsAndWarnings || []}
			testId="aura-fails-warnings"
		/>
		<MessageSection
			title={VERBIAGE_CONSTANTS.AURA_VERIFICATION_TITLE}
			items={messages?.verification || []}
			testId="aura-verification"
		/>
	</Stack>
);

export default AuraEligibilityMessages;
